import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CART_URL = 'https://bienestardigital.click/cart/add?id=43120004464729&quantity=1';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-2xl px-4 py-3" data-id="element-200">
      <a href={CART_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-brand-pink-600 text-white font-bold py-4 px-6 rounded-full shadow-lg active:scale-[0.98] transition-all" data-id="element-201">
        EMPEZAR AHORA — $14.990
        <ArrowRightIcon className="w-5 h-5" data-id="element-202" />
      </a>
      <div className="flex items-center justify-center gap-3 mt-2" data-id="element-203">
        <span className="text-xs text-gray-400 line-through" data-id="element-204">$139.890</span>
        <span className="text-xs font-bold text-emerald-600" data-id="element-205">88% OFF</span>
        <span className="text-xs text-gray-400" data-id="element-206">🛡️ Garantía 7 días</span>
      </div>
    </div>;
}